const MemberList = () => import('Views/member/member-list');
const MemberDetail = () => import('Views/member/member-detail');
const MemberIntegral = () => import('Views/member/member-integral');

export default[
  { path: '/member-list', component: MemberList },
  { path: '/member-detail/:id', component: MemberDetail },
  { path: '/member-integral/:id', component: MemberIntegral },
];



// WEBPACK FOOTER //
// ./src/router/member.js